import { useEffect } from 'react';
import debounce from 'lodash/debounce';

import store from '@/store/smartclass';
import { CHANGE_BREAKPOINT_SUCCESS } from '@/action-types/breakpoint';

const useResizeHandler = () => {
  useEffect(() => {
    const debounceBp = debounce(() => {
      store.dispatch({ type: CHANGE_BREAKPOINT_SUCCESS });
    }, 200);

    window.addEventListener('resize', debounceBp);
    debounceBp();

    return () => {
      window.removeEventListener('resize', debounceBp);
    };
  }, []);
};

export default useResizeHandler;
